<template>
    <drag-modal :visible="$store.state.dislog.agentbox" @cancel="close" title='代理人信息'
        :width="agentStepList.length > 0 ? '75%' : '400px'">
        <div class="agentbox" v-if="agentStepList.length > 0">
            <div class="agent-step-container">
                <div v-for="(item1, index1) in agentStepList" :key="index1">
                    <div class="step-level-1">
                        <label class="step-label level-1-label"><span class="diamond-content"
                                v-if="item1.list.length > 0">{{ item1.label
                                }}</span></label>
                        <div class="arrow-container level-1-arrow" v-if="item1.list.length > 0">
                            <span class="arrow"></span>
                        </div>
                        <div class="step-level-2-wrapper">
                            <div class="step-level-2" v-for="(item2, index2) in item1.list" :key="index2">
                                <label class="step-label level-2-label"
                                    :style="{ marginLeft: index2 == 0 ? '10px' : '' }">{{
                                        item2.label }}</label>
                                <div class="arrow-container level-2-arrow" v-if="item2.list.length > 0">
                                    <span class="arrow"></span>
                                </div>
                                <div class="step-level-3-wrapper">
                                    <div class="step-level-3" v-for="(item3, index3) in item2.list" :key="index3">
                                        <label class="step-label level-3-label"
                                            :class="{ longwidth: index1 == 1 && index2 == 1 }"
                                            v-if="item3.stage_outside && item2.list.length > 0">{{ item3.stage_outside
                                            }}</label>
                                        <div class="arrow-container level-3-arrow" v-if="item3.stage_outside">
                                            <span class="arrow"></span>
                                        </div>
                                        <div class="mode-wrapper" :class="{ ml_20: item3.stage_outside }">
                                            <div class="mode-item">
                                                <label>费用模式：</label>
                                                <span>{{ item3.cost_model }}</span>
                                            </div>
                                            <div class="mode-item">
                                                <label>代理模式：</label>
                                                <span>{{ item3.agent_model }}</span>
                                            </div>
                                            <div class="mode-item">
                                                <label>代理人：</label>
                                                <div class="namecard"
                                                    :class="{ namewidth1: index1 == 1 && index2 == 1, namewidth2: index1 > 1 }">
                                                    <div v-for="(it, ind) in item3.agent" :key="ind">
                                                        <Normap
                                                            :tit="it.name + (it.workplace || it.certificate_number ? '（' : '') + it.workplace + (it.workplace && it.certificate_number ? ',' : '') + it.certificate_number + (it.workplace || it.certificate_number ? '）' : '')">
                                                        </Normap>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="line"></div>
                </div>
            </div>
        </div>
    </drag-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import { stageinfoList } from '../../../server/directory'
export default {
    props: {
        i: Object,
        agent_model: String
    },
    name: 'agentinfoModel',
    computed: {
        ...mapGetters([
            'debInfo',
            'APIKEY',
        ])
    },
    data() {
        return {
            loading: false,
            agentStepList: [
                {
                    label: '诉讼阶段',
                    list: [
                        {
                            label: '立案',
                            list: []
                        },
                        {
                            label: '开庭',
                            list: []
                        },
                    ]
                },
                {
                    label: '执行阶段',
                    list: [
                        {
                            label: '立案',
                            list: []

                        },
                        {
                            label: '执行',
                            list: []

                        },
                    ]
                },
                {
                    label: '公安侦查',
                    list: [
                        {
                            label: '诉讼',
                            list: []

                        },
                        {
                            label: '执行',
                            list: []

                        }
                    ]
                },
                {
                    label: '审判监督',
                    list: [
                        {
                            label: '诉讼',
                            list: []

                        },
                        {
                            label: '执行',
                            list: []

                        }
                    ]
                }
            ]
        }
    },
    created() {
        stageinfoList(this.$store.state.cause.id).then(res => {
            let list = res.list
            const listMappings = [
                ['ss.la', 0, 0], // ss.la → 诉讼阶段-立案
                ['ss.kt', 0, 1], // ss.kt → 诉讼阶段-开庭
                ['zx.la', 1, 0], // zx.la → 执行阶段-立案
                ['zx.zx', 1, 1], // zx.zx → 执行阶段-执行
                ['ga.ss', 2, 0], // ga.ss → 公安侦查-诉讼
                ['ga.zx', 2, 1], // ga.zx → 公安侦查-执行
                ['sp.ss', 3, 0], // sp.ss → 审判监督-诉讼
                ['sp.zx', 3, 1]  // sp.zx → 审判监督-执行
            ]

            // 2. 赋值：仅给有数据的项赋值（避免空数组覆盖）
            listMappings.forEach(([path, level1, level2]) => {
                // 解析嵌套路径（如'ss.la' → list.ss.la），容错：路径不存在返回空数组
                const value = path.split('.').reduce((obj, key) => obj[key] || [], list)
                if (Array.isArray(value) && value.length > 0) {
                    // 确保层级存在（容错）
                    if (!this.agentStepList[level1]) this.agentStepList[level1] = { label: '', list: [] }
                    if (!this.agentStepList[level1].list[level2]) this.agentStepList[level1].list[level2] = { label: '', list: [] }
                    // 赋值：覆盖对应层级的list
                    this.agentStepList[level1].list[level2].list = value
                }
            })

            // 3. 过滤空项：从内到外过滤，确保只保留有数据的层级
            this.agentStepList = this.agentStepList.map(item1 => {
                // 过滤二级项：移除list为空的二级项（如立案/开庭）
                item1.list = item1.list.filter(item2 => {
                    return Array.isArray(item2.list) && item2.list.length > 0
                })
                return item1
            })
                .filter(item1 => {
                    // 过滤顶级项：移除list为空的顶级项（如诉讼阶段/执行阶段）
                    return item1.list.length > 0
                })
        })
    },
    methods: {
        close() {
            this.$store.dispatch('openkey', { key: 'agentbox', by: false })
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        visibleShow(name) {
            this.$store.dispatch("openkey", { key: name, by: true })

        },
    }
}
</script>
<style scoped>
.agentbox {
    box-sizing: border-box;
}

/* 整体容器：统一字体和间距 */
.agent-step-container {
    font-size: 0.875rem;
    color: #333;
    background-color: #6bb1fc15;
    min-height: 100px;
    /* 设置最小高度，避免内容为空时分隔线消失 */
}

/* ss区域容器 */
.step-level-1-container {
    padding-right: 20px;
    /* 给分隔线留出空间 */
}

/* 通用标签样式 */
.step-label {
    white-space: nowrap;
    font-weight: 500;
}

/* 通用箭头样式：绝对定位 + 居中 */
.arrow {
    position: absolute;
    content: "";
    width: 20px;
    height: 20px;
    margin-top: -10px;
    background: url("../../../assets/img/arrow.png") no-repeat center;
    background-size: contain;
}

/* 分隔线样式：绝对定位 + 垂直贯穿 */
.line {
    height: 8px;
    width: 100%;
    background-color: #ffffff;
    /* 改为白色 */
}

/* ---------------- 一级节点样式 ---------------- */
.step-level-card {
    /* display: flex;
    flex-wrap: wrap; */
    padding-left: 20px;
    /* 给分隔线留出空间 */
}

.step-level-1 {
    display: flex;
    align-items: center;
    /* 一级节点整体垂直居中 */
    margin-bottom: 0px;
    /* 一级节点之间的间距 */
    position: relative;
    padding: 20px;
    /* border-right: 1px solid #1d8bfe; */
}

/* 一级标签容器：相对定位，用于箭头定位 */
.level-1-label-wrap {
    position: relative;
    padding-right: 30px;
    /* 给箭头留出空间 */
    height: 100%;
    display: flex;
    align-items: center;
}

.level-1-label {
    font-size: 1rem;
    background-color: #1d8bfe;
    color: #fff;
    /* color: #1d8bfe; */
    /* border: 1px solid #1d8bfe; */
    border-radius: 50%;
    padding: 8px 12px;
}

.diamond {
    width: 120px;
    height: 55px;
    clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
    background: linear-gradient(135deg, #1d8bfe 0%, #0078ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 8px rgba(29, 139, 254, 0.2);
}

/* 一级箭头：指向二级节点，自动斜向分布 */
.level-1-arrow {
    margin-left: 5px;
}

/* 二级节点容器：纵向排列 + 居中对齐 */
.step-level-2-wrapper {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    /* flex-direction: column; */
    gap: 20px;
    /* 二级节点（立案/开庭）之间的间距，影响箭头角度 */
}

/* ---------------- 二级节点样式 ---------------- */
.step-level-2 {
    display: flex;
    align-items: center;
    /* 二级节点整体垂直居中 */
    position: relative;
    margin-left: 20px;
}

.level-2-label-wrap {
    position: relative;
    padding-right: 30px;
    display: flex;
    align-items: center;
}

.level-2-label {
    font-size: 0.875rem;
    background-color: #1d8bfe;
    color: #fff;
    /* color: #1d8bfe; */
    /* border: 1px solid #1d8bfe; */
    border-radius: 4px;
    padding: 0 6px;
}

.level-2-arrow {
    margin-left: 10px;
}

/* 三级节点容器：纵向排列 + 居中对齐 */
.step-level-3-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-left: 10px;
}

/* ---------------- 三级节点样式 ---------------- */
.step-level-3 {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 20px;
}

.level-3-label {
    font-size: 0.875rem;
    background-color: #1d8bfe;
    color: #fff;
    border-radius: 4px;
    padding: 0 6px;
    box-sizing: border-box;

}

.longwidth {
    width: 66px;
    text-align: center;
}

/* 三级箭头：横向指向代理模式 */
.level-3-arrow {
    position: static;
    margin: 0 5px;
}

/* ---------------- 代理/费用模式容器 ---------------- */
.mode-wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
}

.ml_20 {
    margin-left: 20px;
}

.mode-item {
    display: flex;
    /* align-items: center; */
    align-items: flex-start;
    gap: 5px;
}

.mode-item label {
    white-space: nowrap;
    color: #666;
}

.mode-item span {
    color: #333;
}

.namecard {
    width: 290px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.namewidth1 {
    width: 340px;
}

.namewidth2 {
    width: 370px;
}

/* ---------------- 响应式适配 ---------------- */
@media (max-width: 992px) {
    .agent-step-container {
        padding: 20px;
    }

    .step-level-2-wrapper {
        gap: 30px;
    }

    .step-level-3-wrapper {
        gap: 15px;
    }

    /* 响应式下调整分隔线位置 */
    .line {
        left: 50%;
    }

    .step-level-1-container,
    .step-level-card {
        width: 48% !important;
    }
}
</style>